import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { ActivatedRoute } from "@angular/router";
import { RouterExtService } from '../../../services/previous-route.service';
import { CookieService } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.css']
})


  export class ExploreComponent implements OnInit {
    private readonly notifier: NotifierService;
    constructor(@Inject(DOCUMENT) private document: Document, private homepageService: HomepageService,private route: ActivatedRoute,private routerService: RouterExtService,private cookieService: CookieService,notifierService: NotifierService)
    {
      this.notifier = notifierService;
      this.route.queryParams.subscribe(param => {
        this.exploreId = param['exp-btn-id'];
      });
      this.route.params.subscribe(params => {
        this.responseAPIstatus = true;
        this.pageId = this.route.snapshot.paramMap.get("pageId");
        this.previousUrl = this.routerService.getPreviousUrl();        
        this.loadExplore();
      });
    }
    isNew:boolean = false;
    noData:boolean = false;
    explorePageList:any =[];
    resourceLists:any =[];
    previousUrl: string;
    searchTypeSelect: string = '';
    selectedStyle: string = 'a';
    pageId: any;
    exploreData: any = [];
    responseAPIstatus: boolean = true;
    responseAPIstatusAction: boolean = false;
    showAddButtonModalStatus: boolean = false;
    responseStyleStatus: boolean = true;
    updateExplore: boolean = false;
    changestyleButton: boolean = false;
    showActionStatus: string = '';
    deleteButtonId: number = 0;
    editMode: boolean = false;
    limitToShow: boolean = false;
    userCanEdit: boolean = false;
    exploreBreadCrub: any = [];
    fileToUpload: File = null;
    styleImages:any = [];
    styleCustomImages:any = [];
    librarySetting: any = [];
    enableSearchs: any = [];
    limitToSearch: boolean = false;
    limitToEdit: number = 0;
    limitToArray: any = {
      'availability': false,
      'category' : false,
      'lexile' : false,
      'lexileGrade' : false,
      'lexileCode' : false,
      'fountas' : false,
      'rc' : false,
      'ar' : false,
      'homeLocation' : false
    };
    booleanBoxs: any[] = [{
      'op': '',
      'term': '',
      'in': ''
    }];
    public option = { 
      animation: 150,
      handle: '.my-handle',
      sort: true,
      group: 'widgets', 
      direction : 'vertical', 
      dragoverBubble: true,
      removeCloneOnHide: false ,
      onUpdate: (event: any) => {
        this.onSortFinish(event);
      }
      //onEnd: function (/**Event*/evt) {} 
    }
    exploreEditminRate: string;
    exploreEditreviewerName: string;
    exploreEditcategories: string;
    exploreEditreviewAge: string;
    reviewCategories: any = [];
    checkedCategoryIds: number[] = [];
    reviewStarts: number = 0;
    initialRateNew: number = 0;
    initialRate: number = 0;
    exploreId: string = '';
    // Array of selectable option values in lowercase
    selectOptionLevels: string[] = [
      'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'z+'
    ];

    onRatingChange(event){
      this.initialRate = event.rating
      $(document).find('.messageReview.error').remove();
    }

    toggleCategoryChecked(categoryId: number): void {
      if (this.checkedCategoryIds.includes(categoryId)) {
        this.checkedCategoryIds = this.checkedCategoryIds.filter(id => id !== categoryId);
      } else {
        this.checkedCategoryIds.push(categoryId);
      }
      this.checkedCategoryIds = this.checkedCategoryIds.filter(id => !isNaN(id)); 
    }

    ngOnInit() {
     
      this.previousUrl = this.routerService.getPreviousUrl();    
      if(typeof(this.previousUrl) != 'undefined' && this.previousUrl.indexOf('/recentlist/list') >= 0){
        this.exploreBreadCrub =  this.routerService.getExploreBreadcrumb();
      }  
      this.routerService.setTextUrl('Explore');
      this.document.body.classList.add('inner-page');
      this.document.body.classList.remove('list');
      this.pageId = this.route.snapshot.paramMap.get("pageId");
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
        this.userCanEdit = true   
      }
      this.librarySetting = this.homepageService.getUpdatedConfig();
      this.enableSearchs.push('Basic');
      // Checking advance search if any advance search is enabled or not...
      this.enableSearchs.push('Marc');
      this.enableSearchs.push('Category');
      this.enableSearchs.push('Boolean');
      this.enableSearchs.push('Barcode');
      this.enableSearchs.push('Call');
      this.enableSearchs.push('Lexile');
      this.enableSearchs.push('Fountas');
      this.enableSearchs.push('Reading Counts');
      this.enableSearchs.push('Accelerated Reader');
      // Checking Limit to if any limit is enabled or not...
      if( this.librarySetting.data.settings.search.limitTo.availability.enabled === true){
        this.limitToShow = true;
        this.limitToArray.availability = true;
      } 
      if( this.librarySetting.data.settings.search.limitTo.category.enabled === true){
        this.limitToShow = true;
        this.limitToArray.category = true;
      } 
      if( this.librarySetting.data.settings.search.limitTo.lexile.enabled === true){
        this.limitToShow = true;
        this.limitToArray.lexile;
      }
      if( this.librarySetting.data.settings.search.limitTo.lexileGrade.enabled === true){
        this.limitToShow = true;
        this.limitToArray.lexileGrade = true;;
      }
      if( this.librarySetting.data.settings.search.limitTo.lexileCode.enabled === true){
        this.limitToShow = true;
        this.limitToArray.lexileCode = true;;
      }
      if( this.librarySetting.data.settings.search.limitTo.fountas.enabled === true){
        this.limitToShow = true;
        this.limitToArray.fountas = true;
      }
      if( this.librarySetting.data.settings.search.limitTo.rc.enabled === true){
        this.limitToShow = true;
        this.limitToArray.rc = true;;
      }
      if( this.librarySetting.data.settings.search.limitTo.ar.enabled === true){
        this.limitToShow = true;
        this.limitToArray.ar= true;;
      }
      if( this.librarySetting.data.settings.search.limitTo.homeLocation.enabled === true){
        this.limitToShow = true;
        this.limitToArray.homeLocation = true;;
      }
   
   
    }

    //Initializing explore.
    loadExplore(){
      var token =  localStorage.getItem('token');
      if(token){
        this.homepageService.getExploreButtonStyle().subscribe(( style: any) => {
          if(style.status && style.data){
            this.selectedStyle = style.data;
          } else {
            this.selectedStyle = 'a';
          }
        });
      }
        this.pageId = this.pageId.toString().replace(/\D/g, "");
     
        return this.homepageService.getExploreData(this.pageId, this.exploreId).subscribe(( data: any) => {
          if(data.data){
            var tempA:any = data;         
            this.exploreData.data = data;
            this.exploreData.data.id = data.data.id;
            this.exploreData.data.caption = data.data.caption;
            this.exploreData.data.isHomePage = data.data.isHomePage;
            this.exploreData.data.parentPages = data.data.parentPages;
            this.exploreData.data.description = data.data.description
            this.exploreData.data.buttons = [];
            var temp1:any = [];
            tempA.data.buttons.forEach((jsn,keyJ) => {
              if(jsn.action == 'S' && jsn.target != null){
                let trgt:any = jsn.target;
                //console.log("trgt", trgt);
                trgt = this.stringToJson(trgt);
                //console.log("trgt", trgt);
                if(trgt.type == 'Boolean' || trgt.type == 'bool'){
                  trgt = this.booleanJson(trgt);
                }

                //if(jsn.target.indexOf('{') >= 0 &&  jsn.target.indexOf('}') >= 0){
                  //var trgt:any = JSON.parse(jsn.target);
                //} else {
                  //var trgt:any = 'null';
                //}
                var tempd:any = {
                  id:jsn.id,
                  caption:jsn.caption,
                  visible:jsn.visible,
                  position:jsn.position,
                  action:jsn.action,
                  image:jsn.image,
                  target:trgt
                  //description:jsn.description
                }
              } else {
                var tempd:any = {
                  id:jsn.id,
                  caption:jsn.caption,
                  visible:jsn.visible,
                  position:jsn.position,
                  action:jsn.action,
                  image:jsn.image,
                  target: (jsn.target)? jsn.target : 'null'
                  //description:jsn.description
                }
              }
            // console.log("tempd", tempd);
            temp1.push(tempd);
            });

            this.exploreData.data.buttons = temp1;
            if(this.exploreData.data.caption == 'Home'){
              this.exploreBreadCrub = [];
              this.homepageService.updateBannerText('Explore');
            } else {
              let ind = this.exploreBreadCrub.findIndex(ob => ob['id'] === this.exploreData.data.id);
              if(typeof(ind) != 'undefined' && ind >= 0 ){
                var tempBrd:any = [];
                this.exploreBreadCrub.forEach( (item, index) => {
                  if(index < ind){
                    tempBrd.push(item);
                  }
                });
                this.exploreBreadCrub = tempBrd;
              }
              var temp:object = [];
              temp['id'] = this.exploreData.data.id;
              temp['caption'] = this.exploreData.data.caption;
              //temp['description'] = this.exploreData.data.description;
              this.exploreBreadCrub.push(temp);
              this.routerService.setExploreBreadcrumb(this.exploreBreadCrub);
              this.homepageService.updateBannerText(this.exploreData.data.caption);
            }
            this.responseAPIstatus = false;
            this.responseAPIstatusAction = false; 
            if(this.cookieService.check( 'exploreEditMode') && this.cookieService.get( 'exploreEditMode') == 'true'){
              this.document.body.classList.add('manage-view');
              this.editMode = true;
            } else {
              this.document.body.classList.remove('manage-view');
              this.editMode = false;
            }
          }else{
            this.noData = true;
            this.responseAPIstatus = false;
            this.responseAPIstatusAction = false; 
          }
        });
    
    }
    //Default image on error in image..
    imageError(event){
      $(event.target).attr('src','/assets/images/explore/default.gif');
    }

  //Checking edit mode or not.
  editModeToggle(event){
    event.preventDefault();
    if(this.document.body.classList.contains('manage-view')){
      this.cookieService.set( 'exploreEditMode', 'false', 365,'/'); 
      this.document.body.classList.remove('manage-view');
      this.editMode = false;  
    } else {
      this.cookieService.set( 'exploreEditMode', 'true', 365,'/'); 
      this.document.body.classList.add('manage-view');
      this.editMode = true;
    }
  }

  drop(event) {
    var wid = this.exploreData.data[event.previousIndex].id;
    var newIndex = parseInt(event.currentIndex) + 1;
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    this.pageId = this.pageId.toString().replace(/\D/g, "");
    this.homepageService.reOrderExploreButtons(wid, newIndex,token,this.pageId).subscribe((data) => {      
    
    });
    moveItemInArray(this.exploreData.data, event.previousIndex, event.currentIndex);

  }

  //sort or reordering buttons.
  onSortFinish(evt){
    var wid = $(evt.item).attr('wid');
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    var newIndex = parseInt(evt.newIndex) + 1;
    // this.pageId = this.pageId.toString().replace(/\D/g, "");
    let explorePageId = '0';
    if(this.cookieService.check('loadedtenantconfig') && this.cookieService.get('loadedtenantconfig') !== '*'){
      explorePageId = this.exploreData.data.id;
    }else{
      explorePageId = this.pageId;
    }
    explorePageId = explorePageId.toString().replace(/\D/g, "");
    this.homepageService.reOrderExploreButtons(wid, newIndex,token,explorePageId).subscribe((data) => {
        if(data.status){
        }
    });
  }

  //Saving button status.
  buttonPublishStatus(event,wid, status){
    $(event.target).parents('.explore-btn').find('.loader-inner-container').addClass('show').removeClass('hide');
    var selector = $(event.target);
    if(event.target.nodeName == 'I'){
      var selector = $(event.target).parent();
    }
    if(selector.find('i.fas').hasClass('unpublish')){
      selector.find('i.fas').removeClass('fa-eye').addClass('fa-eye-slash');
      selector.find('i.fas').removeClass('unpublish').addClass('publish');
      selector.parents('.col-lg-2').removeClass('buttonDisable');
    } else if(selector.find('i.fas').hasClass('publish')){
      selector.find('i.fas').addClass('fa-eye').removeClass('fa-eye-slash');
      selector.find('i.fas').removeClass('publish').addClass('unpublish');
      selector.parents('.col-lg-2').addClass('buttonDisable');
    }
   //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    this.homepageService.exploreButtonsPublish(wid, status,token).subscribe((data:any) => {
        $(event.target).parents('.explore-btn').find('.loader-inner-container').addClass('hide').removeClass('show');
        this.notifier.notify( 'success', data.message );      
        this.loadExplore();
    }); 
  }

  //Showing confirm modal.
  showConfirmModal(id){
    this.deleteButtonId = id;
  }

  //Delete button event.
  deleteButton(event){
    this.responseAPIstatusAction = true;
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    this.homepageService.exploreButtonsDelete(this.deleteButtonId,token).subscribe((data:any) => {
        if(data.status){
          this.loadExplore();
          $('#cancelholdsClose').trigger('click');
          this.notifier.notify( 'success', 'The button has deleted successfully');      
        } else {
          this.notifier.notify( 'error', data.message );
        }
    }, (error)=>{
      this.notifier.notify( 'error', error.message );
    }); 
  }

  //Uploading image function.
  uploadImage(files: FileList,event) {
    this.updateExplore = true;
    $(event.target).parents('div.add-explore-modal').find('input[name="submit"]').attr('value','uploading...').attr('disabled','disabled');
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
    }
    this.fileToUpload = files.item(0);
    let formData = new FormData();
    formData.append('file', this.fileToUpload, this.fileToUpload.name);
    this.homepageService.exploreImageUpload(formData,token).subscribe((data:any) => {
      if(data.status){
        $(event.target).parents('div.add-explore-modal').find('input[name="submit"]').attr('value','Save').removeAttr('disabled');
        $(event.target).parents('.modal-body').find('.editwidgets-image').find('img').attr('src', data.data.url);    
        $(event.target).parents('.modal-body').find('input[name="imageName"]').val(data.data.url);
      }
      this.updateExplore = false;
    }, (error)=>{
      this.notifier.notify( 'error', 'Something went wrong.');
      $(event.target).parents('div.add-explore-modal').find('input[name="submit"]').attr('value','Save').removeAttr('disabled');
    });
  }

  //Getting saved images for buttons.
  getExploreImages(){
    this.homepageService.getExploreImage().subscribe((data:any) => {
      if(data.status){
        this.styleImages = data.data;
        this.responseStyleStatus = false;
      }
    });
    this.homepageService.getExploreCustomImage().subscribe((data:any) => {
      if(data.status){
        this.styleCustomImages = data.data;
      }
    });
  }

  //Changing visible status..
  showAction(event, value){
    $('.SelectActionCon').removeClass('show').addClass('hide');
    this.showActionStatus = value;
    if(value === 'E'){
      if(this.reviewCategories.length === 0){
        this.homepageService.getReviewCategories().subscribe((data)=>{ 
          this.reviewCategories = data;
      });
      }
     
    }

    if(value == 'L'){
      if(this.resourceLists.length === 0){
         this.homepageService.getResourcesList({logs: false}).subscribe((data) => {
          this.resourceLists = data.data;         
        });
      }
    }
    if(value == 'V'){
      if(this.explorePageList.length === 0){
     this.homepageService.getExplorePages().subscribe((pageList:any) => {
      this.explorePageList = pageList.data;
    
    });
  }
      var page = $(event.target).parents('.modal-body').find('select[name="pagetogo"]').val();;
      if(page == 0)
        this.isNew = true;
      else
        this.isNew = false;
    }else{
      this.isNew = false;
    }
  }

  //Opening edit modal.
  openEditModal(action, target){
    this.showActionStatus = action;
    this.searchTypeSelect = '';
    this.responseAPIstatusAction = true;
    this.limitToEdit = 0;

    if(action === "S" && target.type === 'Boolean'){
      this.booleanBoxs = target.operators;
    }else{
      this.booleanBoxs = [{
        'op': '',
        'term': '',
        'in': ''
      }];
    }
    if(action == 'L'){
      if(this.resourceLists.length === 0){
         this.homepageService.getResourcesList({logs: false}).subscribe((data) => {
          this.resourceLists = data.data;         
        });
      }
    }
    if(action == 'V'){
      if(this.explorePageList.length === 0){
     this.homepageService.getExplorePages().subscribe((pageList:any) => {
      this.explorePageList = pageList.data;
    
    });
  }
}
 if(action === "E"){
      const params = new URLSearchParams(new URL(target, 'http://library.site').search);
      this.initialRate = parseInt(params.get('minrate'));
      this.exploreEditreviewAge = params.get('reviewage');
      this.exploreEditreviewerName = params.get('reviewername');
      const exploreEditcategories = params.get('categories');
      
      const idStrings = exploreEditcategories.split(',').map(s => s.trim());
      this.checkedCategoryIds = idStrings.map(id => parseInt(id, 10));
      if(this.reviewCategories.length === 0){
        this.homepageService.getReviewCategories().subscribe((data)=>{ 
          this.reviewCategories = data;
      });
      }
    }else{
      this.initialRate = 0;
      this.exploreEditreviewAge = ''
      this.exploreEditreviewerName = ''
      this.checkedCategoryIds = []
    }
    
  }

  //Select image style and save them.
  selectStyleImage(event){
    this.updateExplore = true;
    if(event.target.nodeName == 'IMG'){
      var selector = $(event.target).parent();
    } else {
      var selector = $(event.target);
    }
    var img  = selector.attr('imgsrc');
    $(event.target).parents('.modal-body').find('.editwidgets-image').find('img').attr('src', selector.find('img').attr('src'));
    $(event.target).parents('.modal-body').find('input[name="imageName"]').val(img);
    this.updateExplore = false;
  }

  //Editing explore button.
  // Checking for different type of action.
  // If it is search then checking for which type of search it is.
  editEploreButton(event){
    this.updateExplore = true;
    $(document).find('span.error').remove();
    var error:number = 0;
    var buttonId = $(event.target).parents('.modal-body').find('input[name="buttonId"]').val();
    var title:any = $(event.target).parents('.modal-body').find('input[name="title"]').val();
    if($.trim(title) == ''){
      $(event.target).parents('.modal-body').find('input[name="title"]').after('<span class="error">Enter Title</span>');
      error = error+1;
    }
    var actionType = $(event.target).parents('.modal-body').find('select[name="action"]').val();
    if(actionType == '?'){
      $(event.target).parents('.modal-body').find('select[name="action"]').after('<span class="error">Select Action</span>');
      error = error+1;
    }
    var image = $(event.target).parents('.modal-body').find('input[name="imageName"]').val();
    var visible = $(event.target).parents('.modal-body').find('input[name="buttonVisibility"]').val();
    var target:any = null;
    var pageName = null;
    if(actionType == 'V'){
      var target:any = $(event.target).parents('.modal-body').find('select[name="pagetogo"]').val();
      pageName = $(event.target).parents('.modal-body').find('input[name="newPageName"]').val();
    } else if(actionType == 'E'){
      let catForReview = ''
      this.checkedCategoryIds = this.checkedCategoryIds.filter(id => !isNaN(id)); 
      this.checkedCategoryIds.forEach(id => {
        if(catForReview === ''){
          catForReview = id + '';
        }else{
          catForReview += ',' + id;
        }
      });
      target = '/searchreview?';
      target += 'minrate=' + this.initialRate + '&';
      target += 'reviewage=' + $(event.target).parents('.modal-body').find('select[name="review_age"]').val() + '&';
      target += 'reviewername=' + $(event.target).parents('.modal-body').find('input[name="reviewer"]').val() + '&';
      target += 'categories=' + catForReview;  
    } else if(actionType == 'S'){
      var selectedSearchType:any = $(event.target).parents('.modal-body').find('select[name="SearchType"]').val();
      if(selectedSearchType == 'Basic'){
        target = '/search/basic?';
        target += 'keyword='+$(event.target).parents('.modal-body').find('input[name="basicSearchBasic"]').val()+'&';
        target += 'searchin='+$(event.target).parents('.modal-body').find('select[name="basicSearchIn"]').val()+'&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
        
      } else if(selectedSearchType == 'Marc'){   
        target = '/search/marc?';
        target += 'keyword='+$(event.target).parents('.modal-body').find('input[name="marcSearchBasic"]').val()+'&';
        target += 'searchin='+$(event.target).parents('.modal-body').find('select[name="marcSearchIn"]').val()+'&';
        target += 'exact='+$(event.target).parents('.modal-body').find('input[name="marcStartExact"]').is(':checked');
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
        
      }
      else if (selectedSearchType == 'Category') {
        target = '/search/category?';
        target += 'categoryId=' + $(event.target).parents('.modal-body').find('select[name="category"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      }
      else if (selectedSearchType == 'Boolean') {
        target = '/search/bool?';        
        var boxCount = 0;
        var error = 0;
        var firstOperand = "AND";
        $(event.target).parents('.modal-body').find('.boxBoolean').each(function () {
          $(this).find('input[name="terms"]').removeClass('error');
          var terms = $.trim($(this).find('input[name="terms"]').val().toString());
          if (terms != '') {
            var searchIn = $(this).find('select[name="searchIn"]').val();
            var operand = $(this).find('ul.booleanOpretors li.active').text();
            boxCount++;
            if (boxCount != 0) {
              target += '&';
            }
            if (boxCount == 1) {
              target += 'term-' + boxCount + '=' + terms + '&in-' + boxCount + '=' + searchIn + '&op-1=' + firstOperand;
            } else {
              target += 'op-' + boxCount + '=' + operand + '&term-' + boxCount + '=' + terms + '&in-' + boxCount + '=' + searchIn;
            }
          } else {
            $(this).find('input[name="terms"]').addClass('error');
            error++;
          }
        });
        if (boxCount != 0 && error == 0) {
          target += '&count=' + boxCount;
        }
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      } else if(selectedSearchType == 'Barcode'){
        target = '/search/barcode?';
        target += 'start='+$(event.target).parents('.modal-body').find('input[name="barcodeStart"]').val()+'&';
        target += 'end='+$(event.target).parents('.modal-body').find('input[name="barcodeEnd"]').val()+'&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      } else if(selectedSearchType == 'Call'){
        target = '/search/call?';
        target += 'start='+$(event.target).parents('.modal-body').find('input[name="callStart"]').val()+'&';
        target += 'end='+$(event.target).parents('.modal-body').find('input[name="callEnd"]').val()+'&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      } else if(selectedSearchType == 'Lexile'){
        target = '/search/lexile?';
        target += 'levelmin='+$(event.target).parents('.modal-body').find('input[name="LexileLevelMin"]').val()+'&';
        target += 'levelmax='+$(event.target).parents('.modal-body').find('input[name="LexileLevelMax"]').val()+'&';
        target += 'code='+$(event.target).parents('.modal-body').find('select[name="Lexilecode"]').val()+'&';
        target += 'patronType='+$(event.target).parents('.modal-body').find('select[name="LexilePatronType"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      } else if(selectedSearchType == 'Reading Counts'){
        target = 'search/rc?';
        target += 'levelmin='+$(event.target).parents('.modal-body').find('input[name="readingcountsLevelMin"]').val()+'&';
        target += 'levelmax='+$(event.target).parents('.modal-body').find('input[name="readingcountsLevelMax"]').val()+'&';
        target += 'pointmin='+$(event.target).parents('.modal-body').find('input[name="readingcountsPointMin"]').val()+'&';
        target += 'pointmax='+$(event.target).parents('.modal-body').find('input[name="readingcountsPointMax"]').val()+'&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      } else if(selectedSearchType == 'Accelerated Reader'){
        target = '/search/ar?';
        target += 'levelmin='+$(event.target).parents('.modal-body').find('input[name="AcceleratedReaderLevelMin"]').val()+'&';
        target += 'levelmax='+$(event.target).parents('.modal-body').find('input[name="AcceleratedReaderLevelMax"]').val()+'&';
        target += 'pointmin='+$(event.target).parents('.modal-body').find('input[name="AcceleratedReaderPointsMin"]').val()+'&';
        target += 'pointmax='+$(event.target).parents('.modal-body').find('input[name="AcceleratedReaderPointsMax"]').val()+'&';
        target += 'int='+$(event.target).parents('.modal-body').find('select[name="AcceleratedReaderInterestLevel"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      }
      else if (selectedSearchType == 'Fountas') {
        target = '/search/fountas?';
        target += 'levelmin=' + $(event.target).parents('.modal-body').find('select[name="fountasLevelMin"]').val() + '&';
        target += 'levelmax=' + $(event.target).parents('.modal-body').find('select[name="fountasLevelMax"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      }
    } else if(actionType == 'L'){
      var target:any = $(event.target).parents('.modal-body').find('select[name="showSavedList"]').val();
    }  else if(actionType == 'U'){
      var target:any = $(event.target).parents('.modal-body').find('input[name="WebSite"]').val();
    }
    if(error > 0){
      this.updateExplore = false;
      return false;
    }
    //checking explore page no.
    var pageNumber:any = this.pageId;
    if(this.pageId == 0){
      pageNumber = this.exploreData.data?.id;
    }
    if(this.exploreData.data == null){
      pageNumber = 0;
    }
    this.responseAPIstatusAction = true;
    //save explore buttons.
    this.homepageService.saveExploreButton(buttonId,pageNumber, title, visible, actionType,target, image, pageName).subscribe((data:any) => {
      this.updateExplore = false;
      if(data?.status){
        this.loadExplore();
        $(event.target).parents('.add-explore-modal').find('#closeBulletinAdd').trigger('click');
        this.notifier.notify( 'success', data.message );
      } else {
        this.notifier.notify( 'error', data.message );
      }
    });
  }
  getExploreClick(target, id){
    window.open(target, '_blank');
    this.homepageService.getClickExploreBtn(id)
    .subscribe(dat=>{
     
    })
  }
  //add Explore button
  addExploreButton(event){
    this.updateExplore = true;
    $(document).find('span.error').remove();
    var error:number = 0;
    var buttonId = $(event.target).parents('.modal-body').find('input[name="buttonId"]').val();
    var title:any = $(event.target).parents('.modal-body').find('input[name="title"]').val();
    if($.trim(title) == ''){
      $(event.target).parents('.modal-body').find('input[name="title"]').after('<span class="error">Enter Title</span>');
      error = error+1;
    }
    var actionType = $(event.target).parents('.modal-body').find('select[name="action"]').val();
    if(actionType == '?'){
      $(event.target).parents('.modal-body').find('select[name="action"]').after('<span class="error">Select Action</span>');
      error = error+1;
    }
    var image = $(event.target).parents('.modal-body').find('input[name="imageName"]').val();
    var visible = $(event.target).parents('.modal-body').find('input[name="buttonVisibility"]').val();
    var target:any = null;
    var pageName = null;
    if(actionType == 'V'){
      var target:any = $(event.target).parents('.modal-body').find('select[name="pagetogo"]').val();
      pageName = $(event.target).parents('.modal-body').find('input[name="newPageName"]').val();
    } else if(actionType == 'E'){
      let catForReview = ''
      $('input[name="categories_for_review"]:checked').each(function(){
        if(catForReview === ''){
          catForReview = $(this).val() + '';
        }else{
          catForReview += ',' + $(this).val();
        }
      });
      target = '/searchreview?';
      target += 'minrate=' + this.initialRate + '&';
      target += 'reviewage=' + $(event.target).parents('.modal-body').find('select[name="review_age"]').val() + '&';
      target += 'reviewername=' + $(event.target).parents('.modal-body').find('input[name="reviewer"]').val() + '&';
      target += 'categories=' + catForReview;
    } else if(actionType == 'S'){
      var selectedSearchType:any = $(event.target).parents('.modal-body').find('select[name="SearchType"]').val();
      if (selectedSearchType == 'Basic') {
        target = '/search/basic?';
        target += 'keyword=' + $(event.target).parents('.modal-body').find('input[name="basicSearchBasic"]').val() + '&';
        target += 'searchin=' + $(event.target).parents('.modal-body').find('select[name="basicSearchIn"]').val() + '&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      } else if (selectedSearchType == 'Marc') {
        target = '/search/marc?';
        target += 'keyword=' + $(event.target).parents('.modal-body').find('input[name="marcSearchBasic"]').val() + '&';
        target += 'searchin=' + $(event.target).parents('.modal-body').find('select[name="marcSearchIn"]').val() + '&';
        target += 'exact=' + $(event.target).parents('.modal-body').find('input[name="marcStartExact"]').is(':checked');
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      }
      else if (selectedSearchType == 'Category') {
        target = '/search/category?';
        target += 'categoryId=' + $(event.target).parents('.modal-body').find('select[name="category"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      }
      else if (selectedSearchType == 'Boolean') {
        target = '/search/bool?';
        var boxCount = 0;
        var error = 0;
        var firstOperand = "AND";
        $(event.target).parents('.modal-body').find('.boxBoolean').each(function () {
          $(this).find('input[name="terms"]').removeClass('error');
          var terms = $.trim($(this).find('input[name="terms"]').val().toString());
          if (terms != '') {
            var searchIn = $(this).find('select[name="searchIn"]').val();
            var operand = $(this).find('ul.booleanOpretors li.active').text();
            boxCount++;
            if (boxCount != 0) {
              target += '&';
            }
            if (boxCount == 1) {
              target += 'term-' + boxCount + '=' + terms + '&in-' + boxCount + '=' + searchIn + '&op-1=' + firstOperand;
            } else {
              target += 'op-' + boxCount + '=' + operand + '&term-' + boxCount + '=' + terms + '&in-' + boxCount + '=' + searchIn;
            }
          } else {
            $(this).find('input[name="terms"]').addClass('error');
            error++;
          }
        });
        if (boxCount != 0 && error == 0) {
          target += '&count=' + boxCount;
        }

        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      } else if (selectedSearchType == 'Barcode') {
        target = '/search/barcode?';
        target += 'start=' + $(event.target).parents('.modal-body').find('input[name="barcodeStart"]').val() + '&';
        target += 'end=' + $(event.target).parents('.modal-body').find('input[name="barcodeEnd"]').val() + '&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      } else if (selectedSearchType == 'Call') {
        target = '/search/call?';
        target += 'start=' + $(event.target).parents('.modal-body').find('input[name="callStart"]').val() + '&';
        target += 'end=' + $(event.target).parents('.modal-body').find('input[name="callEnd"]').val() + '&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));


      } else if (selectedSearchType == 'Lexile') {
        target = '/search/lexile?';
        target += 'levelmin=' + $(event.target).parents('.modal-body').find('input[name="LexileLevelMin"]').val() + '&';
        target += 'levelmax=' + $(event.target).parents('.modal-body').find('input[name="LexileLevelMax"]').val() + '&';
        target += 'code=' + $(event.target).parents('.modal-body').find('select[name="Lexilecode"]').val() + '&';
        target += 'patronType=' + $(event.target).parents('.modal-body').find('select[name="LexilePatronType"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      } else if (selectedSearchType == 'Reading Counts') {
        target = 'search/rc?';
        target += 'levelmin=' + $(event.target).parents('.modal-body').find('input[name="readingcountsLevelMin"]').val() + '&';
        target += 'levelmax=' + $(event.target).parents('.modal-body').find('input[name="readingcountsLevelMax"]').val() + '&';
        target += 'pointmin=' + $(event.target).parents('.modal-body').find('input[name="readingcountsPointMin"]').val() + '&';
        target += 'pointmax=' + $(event.target).parents('.modal-body').find('input[name="readingcountsPointMax"]').val() + '&';
        target += 'exact=false';
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      } else if (selectedSearchType == 'Accelerated Reader') {
        target = '/search/ar?';
        target += 'levelmin=' + $(event.target).parents('.modal-body').find('input[name="AcceleratedReaderLevelMin"]').val() + '&';
        target += 'levelmax=' + $(event.target).parents('.modal-body').find('input[name="AcceleratedReaderLevelMax"]').val() + '&';
        target += 'pointmin=' + $(event.target).parents('.modal-body').find('input[name="AcceleratedReaderPointsMin"]').val() + '&';
        target += 'pointmax=' + $(event.target).parents('.modal-body').find('input[name="AcceleratedReaderPointsMax"]').val() + '&';
        target += 'int=' + $(event.target).parents('.modal-body').find('select[name="AcceleratedReaderInterestLevel"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));

      }
      else if (selectedSearchType == 'Fountas') {
        target = '/search/fountas?';
        target += 'levelmin=' + $(event.target).parents('.modal-body').find('select[name="fountasLevelMin"]').val() + '&';
        target += 'levelmax=' + $(event.target).parents('.modal-body').find('select[name="fountasLevelMax"]').val();
        target += this.getLimitToTarget($(event.target).parents('.modal-body'));
      }

    } else if(actionType == 'L'){
      var target:any = $(event.target).parents('.modal-body').find('select[name="showSavedList"]').val();
    }  else if(actionType == 'U'){
      var target:any = $(event.target).parents('.modal-body').find('input[name="WebSite"]').val();
    }
    if(error > 0){
      this.updateExplore = false;
      return false;
    }
    //checking explore page no.
    var pageNumber:any = this.pageId;
    if(this.pageId == 0){
      pageNumber = this.exploreData.data?.id;
    }
    if(this.exploreData.data == null){
      pageNumber = 0;
    }
    this.responseAPIstatusAction = true;
    //save explore buttons.
    this.homepageService.saveExploreButton(buttonId,pageNumber, title, visible, actionType,target, image, pageName).subscribe((data:any) => {
      this.updateExplore = false;
      if(data?.status){
        this.loadExplore();
        $(event.target).parents('.add-explore-modal').find('#closeBulletinAdd').trigger('click');
        this.notifier.notify( 'success', data.message );
      } else {
        this.notifier.notify( 'error', data.message );
      }
    });
  }

  //Selecting style.
  selectStyle(event){
    this.changestyleButton = true;
    event.preventDefault();
    $('.graphic-style-modal-box').find('a.style').removeClass('selected');
    var selector:any = $(event.target);
    if(event.target.nodeName != 'A'){
      var selector:any  = $(event.target).parents('a.style');
    }
    selector.addClass('selected');
    var style = selector.attr('attr.type');
    this.homepageService.updateButtonsStyles(style).subscribe((data:any) => {
      this.changestyleButton = false;
      if(data.status){
        this.loadExplore();
        $('#StyleButtonsClose').trigger('click');
        this.notifier.notify( 'success', data.message );
      } else {
        this.notifier.notify( 'error', data.message );
      }
    });
  }

  //showing add button
  showAddButtonModal(){
    this.booleanBoxs = [{
      'op': '',
      'term': '',
      'in': ''
    }];
    this.showAddButtonModalStatus = true;
    this.showActionStatus = '';
    this.limitToSearch = false;
  }

  //hiding add button.
  hideAddButtonModal(){
    this.showAddButtonModalStatus = false;
    this.limitToSearch = false;
  }

  //Looking sor search type (showing corrct div).
  searchTypeOptions(event, value){
    $(event.target).parents('.modal-body').find('.searchOptionsCont').removeClass('showBlock').addClass('hide');
    this.searchTypeSelect = value;
  }

  //Validating search before saving..
  validateSearch(event, searchType, fieldType){
    $(event.target).parent().find('.errorMessage').remove();
    let inputValue = $.trim($(event.target).val().toString());
    let min   = $(event.target).attr('min');
    let max   = $(event.target).attr('max');
    let steps = $(event.target).attr('step');
    let group = $(event.target).attr('group');
  if(searchType != 'Lexile'){
      /* Add Zero to the float vaue if not have */
      if(inputValue.indexOf('.') >= 0){
        var checkFlt = inputValue.split('.');
        if(checkFlt[0] == ''){
          inputValue = '0'+inputValue;
          $(event.target).val(inputValue);
        }
      }
      
      /* Set minimum and maximum  values if less and greater to range*/
      if(parseFloat(inputValue) > parseFloat(max) || parseFloat(inputValue) < parseFloat(min) ){
        if(typeof($(event.target).attr('ismin')) != 'undefined'){
          $(event.target).val(min).removeClass('error');
          $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
        } else {
          $(event.target).val(max).removeClass('error');
          $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
        }
        setTimeout(function(){
          $(event.target).focus().removeClass('error');
        },10);
      } else {
        if(typeof($(event.target).attr('ismin')) != 'undefined'){
          var MaxValue = $.trim($('input#'+group+'Max').val().toString());
          if(MaxValue != '' && (parseFloat(MaxValue) <  parseFloat(inputValue)))
          {
            $(event.target).val(min).removeClass('error');
            return false;
          }
        } else {
          var MinValue = $.trim($('input#'+group+'Min').val().toString());
          if(MinValue != '' && (parseFloat(MinValue) >  parseFloat(inputValue)) )
          {
            $(event.target).val(max).removeClass('error');
            $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
            return false;
          }
        }
        /* Check for values in case of step 0.5 */
        if(steps == '0.5'){
          var near = this.nearest(inputValue).toString();
          if(near.indexOf('.') == -1 ){
            $(event.target).val(near+'.0').removeClass('error');
            $(event.target).val(near).removeClass('error');
          }
        }
      }
    } else {
       $(event.target).removeClass('error');  
       if(parseFloat(inputValue) > parseFloat(max) || parseFloat(inputValue) < parseFloat(min) ){
        if(typeof($(event.target).attr('ismin')) != 'undefined'){
          $(event.target).val(min).removeClass('error');
           $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
        } else {
          $(event.target).val(max).removeClass('error');
           $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
        }        
        setTimeout(function(){
          $(event.target).focus().removeClass('error');            
        },10);
      } else if(typeof($(event.target).attr('ismin')) != 'undefined'){
        var MaxValue = $.trim($('input#'+group+'Max').val().toString());            
        if(MaxValue != '' && (parseFloat(MaxValue) <  parseFloat(inputValue)))
        {
          $(event.target).val(min).removeClass('error');  
           $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
          return false;
        }
      } else {
        var MinValue = $.trim($('input#'+group+'Min').val().toString());            
        if(MinValue != '' && (parseFloat(MinValue) >  parseFloat(inputValue)) )
        {
          $(event.target).val(max).removeClass('error');  
           $(event.target).parent().append('<span class="errorMessage">Enter value between '+min+' to '+max+'</span>');
          return false;
        }
      }
    }
  }

  //Getting approx value.
  nearest(value) {
    return (Math.round(value*2)/2);
  }

  //Seleceting boolean operator.
  selectOpretor(event){
    $(event.target).parent().find('li').removeClass('active');
    $(event.target).addClass('active');
  }

  //Copy box to add another condition.
  copyOpretorBox(event){
    var index = $(event.target).index();
    var op = $.trim($(event.target).text());
    this.booleanBoxs.push({'op': op,'term': '','in': ''});    
  }

  //Removing condition box.
  removeOpretorBox(event){
    var ind = $(event.target).parents('.row.boxBoolean').index();      
    this.booleanBoxs.splice( ind, 1);      
  }

  //Changinf BE response to JSON.
  stringToJson(url){
    var temp:any = [];
    var params:any = {};
    if(url){
      temp = url.split('?');
      temp.forEach(function(data, key){
        var tmp:any = [];
        if(key == 0){
          tmp = data.split('/');
          if(tmp[2] == 'basic') tmp[2] = 'Basic';
          if(tmp[2] == 'boolean') tmp[2] = 'Boolean';
          if(tmp[2] == 'barcode') tmp[2] = 'Barcode';
          if(tmp[2] == 'call') tmp[2] = 'Call';
          if(tmp[2] == 'ar') tmp[2] = 'AcceleratedReader';
          if(tmp[2] == 'fountas') tmp[2] = 'Fountas';
          if(tmp[2] == 'lexile') tmp[2] = 'Lexile';
          if(tmp[2] == 'marc') tmp[2] = 'Marc';
          if(tmp[2] == 'category') tmp[2] = 'Category';
          if(tmp[2] == 'rc') tmp[2] = 'ReadingCounts';
          params['type'] = tmp[2];
        }else{
          tmp = data.split('&');
          tmp.forEach(function(d,k){
            var tp:any = [];
            tp = d.split('=');
            params[tp[0]] = tp[0] == 'in' ? tp[1].toUpperCase() : tp[1];
          });
        }
        
      });return JSON.parse(JSON.stringify(params));
    }else{
      
    }
  }

  //Checking boolean search parameters...
  booleanJson(url){
    //console.log("url", url);
    var params:any = {};
    params['type'] = (url.type == 'bool') ? 'Boolean' : url.type;
    params['count'] = url.count;
    params['operators'] = [];
    for(var i = 1; i <= url.count; i++){
      var temp:any = {
        'op':url['op-'+i] ? url['op-'+i] : 'and',
        'term':url['term-'+i]? url['term-'+i] : '' ,
        'in':url['in-'+i] ? url['in-'+i] : url['by-'+i] ? url['by-'+i] : '',
      }
      params['operators'].push(temp);
    }
    if("l-cat" in url){
      params["l-cat"] = url["l-cat"];
    }
    if("l-inlib" in url) {
      params["l-inlib"] = url["l-inlib"];
    }
    if("l-lexmin" in url) {
      params["l-lexmin"] = url["l-lexmin"];
      params["l-lexmax"] = url["l-lexmax"];
      params["l-lexcode"] = url["l-lexcode"];
      params["l-lexpat"] = url["l-lexpat"];
    }
    if("l-armin" in url) {
      params["l-armin"] = url["l-armin"];
      params["l-armax"] = url["l-armax"];
      params["l-arminpt"] = url["l-arminpt"];
      params["l-armaxpt"] = url["l-armaxpt"];
      params["l-arint"] = url["l-arint"];
    }
    if("l-rcmin" in url) {
      params["l-rcmin"] = url["l-rcmin"];
      params["l-rcmax"] = url["l-rcmax"];
      params["l-rcminpt"] = url["l-rcminpt"];
      params["l-rcmaxpt"] = url["l-rcmaxpt"];
    }
    if("l-fpmin" in url) {
      params["l-fpmin"] = url["l-fpmin"];
      params["l-fpmax"] = url["l-fpmax"];
    }
    return JSON.parse(JSON.stringify(params));
  }

  //This will create the modern url.
  queryToJsonTest(queryStringReview: any, exploreId: string){
    const params = new URLSearchParams(new URL(queryStringReview, 'http://library.site').search);
    const minRate = params.get('minrate');
    const reviewAge = params.get('reviewage');
    const reviewerName = params.get('reviewername');
    const categories = params.get('categories');
    var urlParams:any = {
      minrate: minRate || '',
      reviewage: reviewAge || '',
      reviewername: reviewerName || '',
      categories: categories || '',
      "exp-btn-id": exploreId ,
    };
    return urlParams;
  }

  queryToJson(url, exploreId){
    if (typeof url === 'object' && url !== null) {
    var urlParams:any = {};
    var temp:any = [];
    var parameter: string = '';
    if(url.type == 'Boolean' ){
      urlParams.type = url.type;
      urlParams.count = url.count;
      url.operators.forEach((data,key) =>{
        parameter += 'term-'+(key+1)+ '='+ data.term+'&';
        parameter += 'in-'+(key+1)+'='+ data.in+'&';
        parameter += 'op-' + (key + 1) + '=' + (data.op) + (key + 1 !== url.operators.length ? '&' : '');
      });         
      if("l-cat" in url){
        parameter +="&l-cat="+url["l-cat"];
      }
      if("l-inlib" in url) {
        parameter +="&l-inlib="+url["l-inlib"];
      }
      if("l-lexmin" in url) {
        parameter += "&l-lexmax="+url["l-lexmax"];
        parameter += "&l-lexmin="+url["l-lexmin"];
        parameter += "&l-lexcode="+url["l-lexcode"];
        parameter += "&l-lexpat="+url["l-lexpat"];
      }
      if("l-armin" in url) {
        parameter += "&l-armin="+ url["l-armin"];
        parameter += "&l-armax="+ url["l-armax"];
        parameter += "&l-arminpt="+ url["l-arminpt"];
        parameter += "&l-armaxpt="+ url["l-armaxpt"];
        parameter += "&l-arint="+ url["l-arint"];
      }
      if("l-rcmin" in url) {
        parameter += "&l-rcmin="+ url["l-rcmin"];
        parameter += "&l-rcmax="+ url["l-rcmax"];
        parameter += "&l-rcminpt="+ url["l-rcminpt"];
        parameter += "&l-rcmaxpt="+ url["l-rcmaxpt"];
      }
      if("l-fpmin" in url) {
        parameter += "&l-fpmin="+ url["l-fpmin"];
        parameter += "&l-fpmax="+ url["l-fpmax"];
      }
      urlParams['parameters'] = parameter;
      } else {
      urlParams = url;  
    }
    if(url.type == 'Marc'){
      if(url.exact == 'y')
      url.exact = true;
      if(url.exact == 'n')
      url.exact = false;
    }
    urlParams['exp-btn-id'] = exploreId ? exploreId : '';
    return urlParams;
  }else{
    return url;
  }
  }

  //Converting json.
  extractNameFromJson(obj){
    try{
      if(!obj){
        return false;
      }
      obj = JSON.parse(obj);
    }catch{
      return false;
    }
    return obj;
  }

  //Removing spaces.
  removeSpace(search){
    return search.replace(/\s/g,'');
  }

  //Checking visible operator.
  checkVisible(op1, op2, op3){
    if(op1 != '' && op1.replace(/\s/g,'') == op3){
      return true;
    }else{
      if(typeof(op2) != 'undefined'){
        if(op2.replace(/\s/g,'') == op3 && op1 == ''){
          return true;
        }else{
          return false;
        }
      }else{
        return false;
      }
    }
  }

  //Loader hide.
  hideLoader(){
    this.showActionStatus = '';
    this.responseAPIstatusAction = false;
    this.limitToSearch = false; 
    //this.searchTypeSelect = '';
    
  }

  //Changing value of text on the basis of grade.
  lexileGradeChange(event){
    $('input#LexileLevelMin').val($(event.target).find('option:selected').attr('min'));
    $('input#LexileLevelMax').val($(event.target).find('option:selected').attr('high'));
    $('select#Lexilecode').find('option:eq(0)').prop('selected',true);
  }

  //Limit to functions 
  limitTo(event: any){
    if ($(event.target).hasClass('fas')) {
      if ($(event.target).parent().parent().hasClass('open')) {
          this.limitToSearch = false;
          this.limitToEdit = 1;
         $(event.target).parent().parent().removeClass('open');
      } else {
        this.limitToSearch = true;
        this.limitToEdit = 2;
        $(event.target).parent().parent().addClass('open');
      }
    } else {
      if($(event.target).hasClass('open')) {
          this.limitToSearch = false; 
          this.limitToEdit = 1;
         $(event.target).removeClass('open');
      } else {
        this.limitToSearch = true;
        this.limitToEdit = 2;
        $(event.target).addClass('open');
      }
    }
  }

  //Checking is limit to  applied or not.
  checkForLimit(url, limitToEdit){
  //console.log(url)
    if(limitToEdit == 0){
      if(url.action == 'S'){
      //console.log(url.target);
        if(url.target == null || url.target == 'null'){
          return false;
        } else {
          if("l-cat" in url.target){
            return true;
          }else if("l-inlib" in url.target) {
            return true;
          }else if("l-lexmin" in url.target) {
            return true;
          } else if("l-armin" in url.target) {
            return true;
          } else if("l-rcmin" in url.target) {
            return true;
          } else if("l-fpmin" in url.target) {
            return true;
          } else {
            return false;
          }
        }
      }
    //console.log(url.target);
    }else if(limitToEdit == 1){
      return false;
    }else if(limitToEdit == 2){
      return true;
    }else {
      return false;
    }
  }

  //getting limit to target only (this will add to main target.)
  getLimitToTarget(modal){
    var temp: string = '';
    $(modal).find('input.checkLimit').each(function(this){
      //console.log($(this).attr('name'));
      if($(this).is(':checked') && $(this).attr('name') == 'limitCategory'){
        temp += '&l-cat=' + $(modal).find('select[name=l-cate]').val();
      }
      if($(this).is(':checked') && $(this).attr('name') == 'limitInlib'){
        temp += '&l-inlib=' + $(this).is(':checked');
      }
      if($(this).is(':checked') && $(this).attr('name') == 'limitLexile'){
        temp += '&l-lexmin='+ $(modal).find('input[name=l-lexmin]').val();
        temp += '&l-lexmax='+ $(modal).find('input[name=l-lexmax]').val();
        if(typeof($(modal).find('select[name=l-lexcode]').val()) != 'undefined'){
          temp += '&l-lexcode='+ $(modal).find('select[name=l-lexcode]').val();
        }
        if(typeof($(modal).find('select[name=l-lexpat]').val()) != 'undefined'){
          temp += '&l-lexpat='+ $(modal).find('select[name=l-lexpat]').val();
        }
      }
      if($(this).is(':checked') && $(this).attr('name') == 'limitFountas'){
        temp += '&l-fpmin='+ $(modal).find('#l-fpmin').val();
        temp += '&l-fpmax='+ $(modal).find('#l-fpmax').val();
      }
      if($(this).is(':checked') && $(this).attr('name') == 'limitReading'){
        temp += '&l-rcmin='+ $(modal).find('input[name=l-rcmin]').val();
        temp += '&l-rcmax='+ $(modal).find('input[name=l-rcmax]').val();
        temp += '&l-rcminpt='+ $(modal).find('input[name=l-rcminpt]').val();
        temp += '&l-rcmaxpt='+ $(modal).find('input[name=l-rcmaxpt]').val();
      }
      if($(this).is(':checked') && $(this).attr('name') == 'limitAccelerated'){
        temp += '&l-armin='+ $(modal).find('input[name=l-armin]').val();
        temp += '&l-armax='+ $(modal).find('input[name=l-armax]').val();
        temp += '&l-arminpt='+ $(modal).find('input[name=l-arminpt]').val();
        temp += '&l-armaxpt='+ $(modal).find('input[name=l-armaxpt]').val();
        temp += '&l-arint='+ $(modal).find('select[name=l-arint]').val();
      }
    });
    return temp;
  }


  checkNewPage(event){
    if($(event.target).val() == 0){
      this.isNew = true;
    }else{
      this.isNew = false;
    }
  }
  saveCaption(name){
    this.cookieService.set('exploreButtonName', name, 365, '/');
  }
  addDescription(event){
    var exploreDesc = $(event.target).parents('.addExploreDesc').find('textarea[id="exploreDesc"]').val();
    if(this.pageId == 0){
      this.pageId = this.exploreData.data.id;
    }
    this.homepageService.exploreDescription(this.pageId, exploreDesc).subscribe((data) => {
        if(data.status){
          this.loadExplore();
        }
    });
  }
  editDescription(event){
    var exploreDesc = $(event.target).parents('.editExploreDesc').find('textarea[id="editExploreDesc"]').val();
    if(this.pageId == 0){
      this.pageId = this.exploreData.data.id;
    }
    this.homepageService.exploreDescription(this.pageId, exploreDesc).subscribe((data) => {
        if(data.status){
          this.loadExplore();
        }
    });
  }
}
